import script from "./areaSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./areaSelect.vue?vue&type=script&setup=true&lang=js"

import "./areaSelect.vue?vue&type=style&index=0&id=021d607e&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-021d607e"]])

export default __exports__